import styled from 'styled-components';
import { colors } from 'bench-style-constants';

const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  color: ${colors.charcoal};
`;

export default Title;
